export function buildPlanMetrics(layout, projects) {
  const activePartCount = projects.reduce(
    (total, subproject) => total + subproject.panels
      .filter((panel) => !panel.hidden)
      .reduce((sum, panel) => sum + Math.max(Number(panel.quantity) || 0, 0), 0),
    0,
  );

  const {
    sheetCount,
    newSheetCount = sheetCount,
    restSheetCount = 0,
    partCount,
    utilisation,
  } = layout.metrics;
  const invalidCount = layout.invalid.length;
  const partTotal = activePartCount || partCount;

  let statusClass = "ok";
  let statusKey = null;
  /** @type {Record<string, string | number>} */
  let statusParams = {};

  if (activePartCount === 0) {
    statusKey = "web.planMetrics.addParts";
  } else if (invalidCount > 0) {
    statusClass = "warn";
    statusKey = invalidCount === 1
      ? "web.planMetrics.invalidSingular"
      : "web.planMetrics.invalidPlural";
    statusParams = { count: invalidCount };
  } else if (sheetCount === 0) {
    statusKey = "web.planMetrics.notCalculated";
  } else if (restSheetCount > 0 && newSheetCount === 0) {
    statusKey = restSheetCount === 1
      ? "web.planMetrics.restOnlySingular"
      : "web.planMetrics.restOnlyPlural";
    statusParams = { count: restSheetCount };
  } else if (restSheetCount > 0 && newSheetCount > 0) {
    statusKey = newSheetCount === 1 && restSheetCount === 1
      ? "web.planMetrics.mixedSingular"
      : "web.planMetrics.mixedPlural";
    statusParams = { newCount: newSheetCount, restCount: restSheetCount };
  } else if (sheetCount === 1) {
    statusKey = "web.planMetrics.oneSheet";
  } else if (sheetCount > 1) {
    statusKey = "web.planMetrics.multipleSheets";
    statusParams = { count: sheetCount };
  }

  return {
    activePartCount,
    partTotal,
    sheetCount,
    newSheetCount,
    restSheetCount,
    utilisation,
    invalidCount,
    statusClass,
    statusKey,
    statusParams,
  };
}
